import { HomeHospitalItem } from '@/types/HomeHospital'

export function formatCommaSeparated(num: number): string {
  return `${num}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

export function getDisplayBedCount(bedCount?: number): string {
  if (!bedCount) return ''
  return `${formatCommaSeparated(bedCount)}`
}

export function getDisplayDoctorCount(doctorCount?: number): string {
  if (!doctorCount) return ''
  return `${formatCommaSeparated(doctorCount)}`
}

type GetHospitalTagsArgs = Pick<
  HomeHospitalItem,
  'prefecture' | 'juniorCount' | 'specialistCount'
>

export function getHospitalTags({
  prefecture = '',
  juniorCount,
  specialistCount
}: GetHospitalTagsArgs): string[] {
  const tags = []
  if (prefecture) {
    tags.push(prefecture)
  }
  if (juniorCount && juniorCount > 0) {
    tags.push('初期研修')
  }
  if (specialistCount && specialistCount > 0) {
    tags.push('専門研修')
  }
  return tags
}

export function getFeatureTags(
  discerningConditions?: string[]
): { label: string; disabled: boolean }[] {
  if (!discerningConditions) return []
  return discerningConditions.map((tag) => ({
    label: `${tag}`,
    disabled: false
  }))
}

type HasSomeScoreArgs = Pick<
  HomeHospitalItem,
  'caseScore' | 'instructorScore' | 'salaryScore' | 'magnificationScore'
>

export function hasSomeScore({
  caseScore,
  instructorScore,
  salaryScore,
  magnificationScore
}: HasSomeScoreArgs): boolean {
  return [caseScore, instructorScore, salaryScore, magnificationScore].some(
    (item) => item != null
  )
}

export function getDisplayPublicationDeadline(
  str?: string
): string | undefined {
  if (!str) return undefined
  const splitted = str.split('/')
  return `${splitted[0]}年${splitted[1]}月${splitted[2]}日まで`
}
